// extracted by mini-css-extract-plugin
export default {"formLabel":"SetNewPassword_formLabel__r+JkC","formSubtitle":"SetNewPassword_formSubtitle__HM4ng","formContainer":"SetNewPassword_formContainer__JC6nL"};